import { InjectionToken } from '@angular/core';

export const DYNAMIC_LOCALE = new InjectionToken<string>('DYNAMIC_LOCALE');
